export const environment = {
  apiUrl: 'https://partou-employee.test.m4mapp.com/api/ocs/v1',
  apiPrefix: '/api/v1/',
  baseUrl: 'https://partou-ocs.test.moveagency.dev',
  discoveryUrl: 'https://portaal.partou.nl/oauth2/v2/59675361-aa81-4d4e-bfb8-078f5f9dc855',
  helloIdClientId: '59675361-aa81-4d4e-bfb8-078f5f9dc855',
  production: false,
};
